import { Directive, ElementRef, Renderer } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';

@Directive({
  selector: '[bg-color]'
})
export class BgColorDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer,
    public comProv: CommonProvider
  ) {
    this.setColor();
  }

  setColor() {
    let bg_color = '#ffffff';
    let image;

    if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
      let base_data = JSON.parse(localStorage.getItem('base_data'));
      if (base_data['background_color']) {
        bg_color = base_data['background_color'];
      }
      if (base_data['background_image']) {
        image = base_data['background_image'];
      }
    }
    
    if (image) {
      image = this.comProv.getThumbnailUrl(image, 1080);
      this.renderer.setElementStyle(this.el.nativeElement, 'backgroundImage', 'url(' + image + ')');
      this.renderer.setElementStyle(this.el.nativeElement, 'backgroundSize', '100% auto');

      //this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', 'transparent');
    }
    this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', bg_color);
  }
}


// WEBPACK FOOTER //
// ./src/directives/bg-color/bg-color.ts